import { render, staticRenderFns } from "./course-unit-resources.vue?vue&type=template&id=4b608fcc&scoped=true"
import script from "./course-unit-resources.vue?vue&type=script&lang=js"
export * from "./course-unit-resources.vue?vue&type=script&lang=js"
import style0 from "./course-unit-resources.vue?vue&type=style&index=0&id=4b608fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b608fcc",
  null
  
)

export default component.exports